import Ajax from './ajax.js'
import {config} from '@config/network.js'
export default {
    install(Vue, router) {
        let ajax = null
        if(location.origin.indexOf('localhost') !== -1) {
            ajax = new Ajax(Vue, location.origin, router)
        } else if(location.origin.indexOf('parteco.cn') !== -1) {
            ajax = new Ajax(Vue, '//warehouse-apply.parteco.cn/', router)
        } else if(location.origin.indexOf('qp11.cn') !== -1) {
            ajax = new Ajax(Vue, '//qp11.cn/', router)
        } else {
            ajax = new Ajax(Vue, config.API, router)
        }
        Vue.prototype.$ajax = (name, params, options) => {
            return ajax.sendRequest(name, params, options)
        }
    }
}




// WEBPACK FOOTER //
// ./src/plugins/ajax/index.js